"use client";

import { useState } from "react";
import apiService from "@/app/services/apiService";
import { Star } from "lucide-react";
import { useServiceReviews } from "@/app/hooks/useServiceReviews"; // <-- caminho correto
import { useServiceReviewModal } from "@/app/hooks/useServiceReviewModal"; // opcional
import { useAuthStore } from "@/app/hooks/auth";
import { useEffect } from "react";
import useLoginModal from "@/app/hooks/useLoginModal";

interface ServiceReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function ServiceReviewModal({ isOpen, onClose }: ServiceReviewModalProps) {
  
  // 🔥 Se não estiver aberto → não renderiza NADA
  if (!isOpen) return null;

  const { mutate } = useServiceReviews();
  const user = useAuthStore((s) => s.user);
  const userId = user?.id;

  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const login = useLoginModal();

  useEffect(() => {
    if (isOpen && !userId) {
      onClose();
      login.open();
    }
  }, [isOpen, userId]);


  // NOTA:
  // Não fazemos verificação de login aqui. 
  // Isso é feito APENAS no LeaveReviewButton, que abre o modal.
  // Assim evitamos loops e travamento do modal.

  const submitReview = async () => {

    if (!userId) {
      login.open();
      return;
    }

    if (!comment.trim()) return alert("Por favor escreva um comentário.");

    try {
      setLoading(true);

      await apiService.postWithToken("api/user/service-reviews/create/", {
        rating,
        comment,
        service_type: "platform",
      });

      setLoading(false);
      setComment("");
      setRating(5);

      mutate(); // 🔥 atualiza lista de reviews

      alert("Obrigado pela sua avaliação! 🌟");
      onClose();
    } catch (error) {
      setLoading(false);
      alert("Erro ao enviar avaliação.");
      console.error(error);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl p-6 max-w-lg w-full shadow-xl">
        <h2 className="text-xl font-semibold mb-4 text-center">
          Avalie sua experiência
        </h2>

        {/* Estrelas clicáveis */}
        <div className="flex justify-center gap-1 mb-4">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star
              key={i}
              onClick={() => setRating(i + 1)}
              className={`size-8 cursor-pointer ${
                i < rating ? "text-yellow-500 fill-yellow-500" : "text-gray-300"
              }`}
            />
          ))}
        </div>

        {/* Comentário */}
        <textarea
          className="w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 transition"
          placeholder="Conte sua experiência com beckasmello.com..."
          rows={4}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />

        {/* Botões */}
        <div className="flex justify-end gap-3 mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-full border border-gray-400 text-gray-600 hover:bg-gray-100 transition"
          >
            Cancelar
          </button>

          <button
            onClick={submitReview}
            disabled={loading}
            className="px-4 py-2 rounded-full bg-emerald-500 text-black font-semibold hover:bg-emerald-400 transition shadow-md disabled:opacity-50"
          >
            {loading ? "Enviando..." : "Enviar Avaliação"}
          </button>
        </div>
      </div>
    </div>
  );
}
